import { NgModule, LOCALE_ID } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { AntiFraudComponent } from './components/anti-fraud/anti-fraud.component';
import { HttpClient, provideHttpClient } from '@angular/common/http';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { LandingPageComponent } from './components/landing-page/landing-page.component';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { MenuModule } from 'primeng/menu';
import { InputOtpModule } from 'primeng/inputotp';
import { DialogModule } from 'primeng/dialog';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { RadioButtonModule } from 'primeng/radiobutton';
import { PlatformModule } from '@angular/cdk/platform';
import { PanelModule } from 'primeng/panel';
import { PrivacyPolicyComponent } from './components/privacy-policy/privacy-policy.component';
import { NavbarComponent } from './components/navbar/navbar.component';
import { TermsConditionsComponent } from './components/terms-conditions/terms-conditions.component';
import { FooterComponent } from './components/footer/footer.component';
import { CarouselModule } from 'ngx-owl-carousel-o';
import { ConfirmationService } from 'primeng/api';
import { ConfirmDialogModule } from 'primeng/confirmdialog';
import { ProfileComponent } from './components/profile/profile.component';
import { AppRedirectComponent } from './components/app-redirect/app-redirect.component';
import { DefaultComponent } from './components/default/default.component';

export function HttpLoaderFactory(http: HttpClient) {
  return new TranslateHttpLoader(http, '/assets/i18n/', '.json');
}

@NgModule({
  declarations: [
    AppComponent,
    AntiFraudComponent,
    LandingPageComponent,
    PrivacyPolicyComponent,
    NavbarComponent,
    TermsConditionsComponent,
    FooterComponent,
    ProfileComponent,
    AppRedirectComponent,
    DefaultComponent
  ],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    AppRoutingModule,
    FormsModule,
    ReactiveFormsModule,
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: HttpLoaderFactory,
        deps: [HttpClient]
      }
    }),
    MenuModule,
    InputOtpModule,
    DialogModule,
    RadioButtonModule,
    PlatformModule,
    PanelModule,
    CarouselModule,
    ConfirmDialogModule
  ],
  providers: [provideHttpClient(), ConfirmationService],
  bootstrap: [AppComponent]
})
export class AppModule { }
